<template>
  <social-proof>
    <template #press>
      <div class="press">
        <img
          src="@/assets/homepage/press/le-figaro.svg"
          loading="lazy"
          alt="Le Figaro"
          width="145"
          height="34"
        />
        <img
          src="@/assets/homepage/press/le-parisien.svg"
          loading="lazy"
          alt="Le Parisien"
          width="128"
          height="40"
        />
        <img
          src="@/assets/homepage/press/vogue.svg"
          loading="lazy"
          alt="Vogue"
          width="135"
          height="35"
        />
        <template v-if="$isDesktop">
          <img
            src="@/assets/homepage/press/femme-actuelle.svg"
            loading="lazy"
            alt="Femme Actuelle"
            width="222"
            height="32"
          />
          <img
            src="@/assets/homepage/press/grazia.svg"
            loading="lazy"
            alt="Grazia"
            width="127"
            height="40"
          />
          <img
            src="@/assets/homepage/press/pleine-vie.svg"
            loading="lazy"
            alt="Pleine Vie"
            width="134"
            height="37"
          />
        </template>
      </div>
    </template>
  </social-proof>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import SocialProof from './SocialProof.vue'

@Component({
  mixins: [SocialProof],
})
class SocialProofFr extends Vue {}

export default toNative(SocialProofFr)
</script>
